import React, { useState, useEffect } from "react";
import "./assets/css/common.css";
import { connect } from "react-redux";
import { AppRouter } from "./routes/router";
import { useLocation } from "react-router-dom";
import Header from "./components/Header/Header";
import Footer from "../src/components/Footer";
import { fetchData, fetchInboxMessages, fetchMessagesCounts, receivedMessage, fetchNotification, updateUserInfo } from "./redux/actions";
import { useDispatch, useSelector } from "react-redux";
import "./assets/css/common.css";
import { WS } from "./webSocket/defaultSocket";
import axios from "axios";
import { Modal } from "antd";
import { getCookie, setCookie } from "./shared/helpers";
import { Auth } from '../src/config/aws-exports'
import history from "./routes/history";
import store from "./redux/store";
import moment from "moment";
import ReactGA from "react-ga4";

// import ErrorModal from "./components/ErrorModal/errormodal";

// import WS from "./webSocket/defaultSocket"

function App(props) {

    // Google Analytics Initialization
  ReactGA.initialize('G-T5NQCKKG47');

  const dispatch = useDispatch();
  const [stage, seStage] = useState("");
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/sw.js`)
      .then(() => { });
  }

  const url = useSelector((state) => state.authReducer.url);
  const headerKey = useSelector((state) => state.candidateReducer.headerKey);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  // const [APIerr, setAPIerr] = useState(false);
  // const [errorMgs,setErrormsg] = useState('');
  let userProfile = localStorage.getItem("userProfile");
  let userProfile1 = JSON.parse(localStorage.getItem("userProfile"));

  // useEffect(() => {
  //   (function () {
  //     window.__insp = window.__insp || [];
  //     window.__insp.push(["wid", process.env.REACT_APP_INSPECTLET_ID]);
  //     var ldinsp = function () {
  //       if (typeof window.__inspld != "undefined") return;
  //       window.__inspld = 1;
  //       var insp = document.createElement("script");
  //       insp.type = "text/javascript";
  //       insp.async = true;
  //       insp.id = "inspsync";
  //       insp.src =
  //         ("https:" == document.location.protocol ? "https" : "http") +
  //         `://cdn.inspectlet.com/inspectlet.js?wid=${process.env.REACT_APP_INSPECTLET_ID}&r=` +
  //         Math.floor(new Date().getTime() / 3600000);
  //       var x = document.getElementsByTagName("script")[0];
  //       x.parentNode.insertBefore(insp, x);
  //     };
  //     setTimeout(ldinsp, 0);
  //   })();
  // }, []);

  useEffect(() => {
    if (userProfile1?.AccountId) {
      WS.init(userProfile1?.AccountId);
      WS.onMessage(({ data }) => {
        dispatch(fetchNotification());
        dispatch(fetchInboxMessages("null", "all_conversations", null, 1, 1));
      });
    }
  }, [userProfile1?.AccountId]);

  const receiveStage = (stage) => {
    seStage(stage);
  };

  useEffect(() => {

    // Google Analytics hit page view event
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    
    refreshLoginToken()
    // async function AuthCheck() {
    //   let session = null;

    //   try {
    //     if (getCookie("token") !== null && getCookie("token").length > 0) {
    //       const myToken = getCookie("token");
    //       const cognitoUser = await Auth.currentAuthenticatedUser();
    //       const currentSession = await Auth.currentSession();
    //       console.log('token???',cognitoUser, "&&", currentSession,'&&',myToken )
    //       cognitoUser.refreshSession(
    //         currentSession.refreshToken,
    //         (err, session) => {
    //           // console.log("session", err, session);
    //           const Token = session.idToken.jwtToken;
    //           // do whatever you want to do now :)
    //           // console.log("authToken", talentToken);
    //           setCookie("token", Token, true);
    //           // props.profileDetails(Token);
    //           // props.sendAuthToken(Token);
    //         }
    //       );
    //     }
    //   } catch (err) {
    //     history.push("/login")
    //   }
    // }
    // AuthCheck();
  }, []);

  async function refreshLoginToken() {
    try {
      const currentSession = await Auth.currentSession();
      const accessToken = currentSession.getAccessToken();

      const expirationTime = moment(accessToken.payload.exp * 1000);
      const currentTime = moment();
      const isExpired = expirationTime.isBefore(currentTime);

        const cognitoUser = await Auth.currentAuthenticatedUser();
        cognitoUser.refreshSession(
          currentSession.refreshToken,
          (err, session) => {
            const Token = session.idToken.jwtToken;

            dispatch(updateUserInfo(Token))
            setCookie("token", Token);
          }
        );
    
    } catch (error) {
      console.log('refresh err ===>', error);
    }
  }

  // axios.interceptors.response.use(
  //   (res) => {
  //      // Add configurations here
  //      if (res.status === 200) {
  //         console.log('API Successfully');
  //      }
  //      return res;
  //   },
  //   (err) => {
  //     //  return Promise.reject(err);
  //     //  console.log('APIerr API failed', err);
  //      if(err) {
  //       setAPIerr(true)
  //       setErrormsg(err)
  //     }
  //   }
  // );

  return (
    <React.Fragment>
      <Header
        changeStage={receiveStage}
        stage={stage}
        userProfile={userProfile}
        key={headerKey}
      />
      <AppRouter authToken={props.authToken} shareStage={receiveStage} />

      {/* {window.location.pathname !== "/employer/conversations" && <Footer />} */}
      {<Footer key={headerKey} />}
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    authToken: state.authReducer.user.authToken,
    loading: state.profileReducer.loading,
    user: state.profileReducer.user,
    error: state.profileReducer.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (params) => {
      dispatch(fetchData(params));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
